/**
 * This might look like duplicating what's already in the app, but it is intentional to keep everything in sync.
 * Also some en-us strings still needs to manage plurals and other contextual things.
 */
export default {
  translation: {
    "Welcome to React": "Welcome to React and react-i18next",
    Decoding: "Decoding",
    "Phonological Awareness": "Phonological Awareness",
    "High Frequency Words": "High Frequency Words",
    "Background Knowledge": "Background Knowledge",
    "Structure and Reasoning": "Structure and Reasoning",
    Vocabulary: "Vocabulary",
    "On Track": "On Track",
    "Catch Up": "Catch Up",
    Ahead: "Ahead",
  },
  common: {
    grade_0: "kindergarten",
    grade_1: "first grade",
    grade_2: "second grade",
    grade_3: "third grade",
    grade_4: "fourth grade",
    grade_5: "fifth grade",
    grade_6: "sixth grade",
    English: "English",
    Spanish: "Spanish",
    Confirm: "Confirm",
    Cancel: "Cancel",
    Proceed: "Proceed",
    Create: "Create",
    Continue: "Continue",
    Print: "Print",
    Close: "Close",
    sr_coming_soon:
      "{{brandedAppName}} is not yet calculating data on Structures & Reasoning. This is coming soon.",
    nth_pr: "{{percentile}}th PR",
    PR: "PR",
    ahead: "Ahead",
    catch_up: "Catch Up",
    at_above: "At/Above",
    on_track: "On Track",
    developing: "Developing",
    behind: "Behind",
    Fall: "Fall",
    Winter: "Winter",
    Spring: "Spring",
    Summer: "Summer",
    arm_score: "ARM Score",
  },
  arm_floor: {
    arm_floor_tooltip_content:
      "Based on National Norms, {{name}}'s ARM Score indicates they should be considered two or more grade levels behind.",
  },
  teacher_parent_report: {
    "a 0 grade": "a kindergarten",
    "a 1 grade": "a first grade",
    "a 2 grade": "a second grade",
    "a 3 grade": "a third grade",
    "a 4 grade": "a fourth grade",
    "a 5 grade": "a fifth grade",
    "a 6 grade": "a sixth grade",
    "a 7 grade": "a seventh grade",
    "a 8 grade": "an eighth grade",
    "a 0 grader": "a kindergartener",
    "a 1 grader": "a first grader",
    "a 2 grader": "a second grader",
    "a 3 grader": "a third grader",
    "a 4 grader": "a fourth grader",
    "a 5 grader": "a fifth grader",
    "a 6 grader": "a sixth grader",
    "a 7 grader": "a seventh grader",
    "a 8 grader": "an eighth grader",
    "0 month": "beginning",
    "1 month": "first month",
    "2 month": "second month",
    "3 month": "third month",
    "4 month": "fourth month",
    "5 month": "fifth month",
    "6 month": "sixth month",
    "7 month": "seventh month",
    "8 month": "eight month",
    "9 month": "ninth month",
    "10 month": "tenth month",
    "the student": "the student",
    "the student_plural": "the students",
    "Oral Reading Fluency Progress": "Oral Reading Fluency Progress",
    "Tips For Helping {{name}} Right Now":
      "Tips For Helping {{name}} Right Now",
    "Understanding {{name}}'s Scores": "Understanding {{name}}'s Scores",
    parent_orf_score_tooltip:
      "Words Correct Per Minute (WCPM) is the standard measure of Oral Reading Fluency. Estimated Vocabulary size is a good indication of a student's level of comprehension and world knowledge. In both cases, the larger the number the better.",
    "Parent Report for {{name}}": "Parent Report for {{name}}",
    parent_arm_score_tooltip:
      "Your child's ARM score relates to their level of reading as it pertains to an age level measurement. Consider it as close to the age at which they are reading independently. An ARM score starting with 5 indicates a reading score of a typical 5 year old (which is in the kindergarten band.) Estimated Vocabulary size is a good indication of a student's level of comprehension and world knowledge. In both cases, the larger the number the better.",
    student_overall_arm_description:
      "{{name}}’s overall reading mastery score is a measure of fluency. It shows the grade level at which {{name}} is reading independently. A score of {{score}} is {{pacing}}.",
    student_overall_wcpm_description:
      "Words correct per minute (WCPM) is a measure of reading fluency. A WCPM of {{score}} is {{pacing}}.",
    BELOW_GRADE_LEVEL: "Catch Up",
    AT_GRADE_LEVEL: "On Track",
    AHEAD_OF_GRADE_LEVEL: "Ahead",
    Decoding: "Decoding",
    "Phonological Awareness": "Phonological Awareness",
    "Sight Recognition": "High Frequency Words",
    "High Frequency Words": "High Frequency Words",
    "Background Knowledge": "Background Knowledge",
    "Structure & Reasoning": "Structure & Reasoning",
    Vocabulary: "Vocabulary",
    Decoding_description:
      "Decoding is matching letters to sounds. For example: knowing the “c” in cat makes a “k” sound.",
    domain_descriptions: {
      Decoding: "Decoding is matching letters to sounds.",
      "Phonological Awareness":
        "Phonological Awareness is knowing how words are made up of sounds.",
      "Sight Recognition":
        "High frequency words are words that are very common. Readers will learn to recognize these and read them without sounding them out.",
      "Background Knowledge":
        "Background knowledge is knowing about a topic generally in order to better understand a story about that topic.",
      "Structure & Reasoning":
        "Structures and reasoning refers to the analysis, evaluation and synthesis of the text.",
      Vocabulary:
        "Vocabulary refers to knowledge of the meanings of individual words being read. It is important to a student’s ability to read and comprehend what is read.",
    },
    "{{name}}'s Overall Reading Mastery": "{{name}}'s Overall Reading Mastery",
    "Batch Print": "Batch Print",
    "Scored better than {{percentage}}% of students":
      "Scored better than {{percentage}}% of students",
    "The {{leftScore}} to the left of the decimal indicates {{studentName}} is reading at {{currentGradeString}} level. The .{{rightScore}} to the right of the decimal indicates {{studentName}} is {{rightScore}}% of the way to {{nextGradeString}} reading level.":
      "The {{leftScore}} to the left of the decimal indicates {{studentName}} is reading at {{currentGradeString}} level. The .{{rightScore}} to the right of the decimal indicates {{studentName}} is {{rightScore}}% of the way to {{nextGradeString}} reading level.",
    "{{name}}'s Reading Subscores": "{{name}}'s Reading Subscores",
    parent_arm_score_info:
      "The Amira Reading Mastery (ARM) score shows the grade level at which {{studentName}} is reading independently.",
    left_score_description:
      "The {{leftScore}} to the left of the decimal represents {{currentGradeString}} reading level.",
    right_score_description:
      "The .{{rightScore}} to the right of the decimal indicates the {{rightScoreDescription}} of the school year.",
    print_language_label: "Print Language",
  },
  teacher_report_chart_progress: {
    WCPM: "WCPM",
    "Student’s ability to read aloud with natural ease":
      "Student’s ability to read aloud with natural ease",
    Lexile: "Lexile measure (based on grade equivalency)",
    AREA: "AREA",
    "Amira Reading Estimated Age": "Amira Reading Estimated Age",
    ESRI: "EHFWI",
    "Expected High Frequency Words Inventory":
      "Expected High Frequency Words Inventory",
    PSF: "PSF",
    "Phoneme Segmentation Fluency": "Phoneme Segmentation Fluency",
    EVS: "EVS",
    "Estimated words in vocabulary": "Estimated words in vocabulary",
    ARM: "ARM",
    "Amira reading mastery": "Amira reading mastery",
    "Latest Score": "Latest Score",
    "Predicted Ability": "Predicted Ability",
    "Estimated Mastery": "Estimated Mastery",
    Excellent: "Excellent",
    Average: "Average",
    "Below Expectations": "Below Expectations",
    Jan: "Jan",
    Feb: "Feb",
    Mar: "Mar",
    Apr: "Apr",
    May: "May",
    Jun: "Jun",
    Jul: "Jul",
    Aug: "Aug",
    Sep: "Sep",
    Oct: "Oct",
    Nov: "Nov",
    Dec: "Dec",
  },
  teacher_dyslexia_letter: {
    Dear: "Dear",
    Sincerely: "Sincerely",
    parent_letter_p1:
      "Thank you for your continued partnership in providing the best education for {{name}}. Each year, all students in our community participate in a dyslexia screener provided by Amira. The screener is similar to a reading assessment with students completing a variety of literacy tasks. This screener provides notices of risk for dyslexia and is not a diagnosis. Approximately 1 in 5 people are diagnosed with dyslexia and early detection through screening is imperative for helping these and all students reach their reading potential. For more information about dyslexia, visit",
    parent_letter_p2:
      "Your child completed the Amira dyslexia screener on {{date}}. The screening results are below. You should read these results like a gauge on the dashboard of a car. Just like a dashboard provides signals on different aspects of the car's status, this screener indicates which skills are strengths or areas for growth for your child. This information can be valuable for you, your child, and obviously for us as the school helping them attain their academic goals. Through the screener, we've learned about your child's abilities in different tasks including: letter naming, segmenting the sounds in words, and decoding through matching letters and sounds. All children have strength skills and areas for improvement.",
    parent_letter_p3:
      "The results from the dyslexia screener indicates {{name}} has reading struggles or areas for improvement that are often associated with dyslexia. It is important to remember that this screener is a signal of dyslexia risk and not a formal diagnosis. Based on these results, {{name}} might be considered for additional assessment or support -- but for now, it's important than you review the results and consider reading a priority for your child.  About 1 in 5 students show signs of dyslexia risk, so it's important to be informed and active.",
    parent_letter_p4:
      "If you'd like to better understand these results or your role in supporting your child, please contact me so we can find a time to do so.  As your child's teacher, I will continue to monitor your child's progress, update you on their skills, and provide tools to support reading growth.",
    parent_letter_p5:
      "If you have any questions, I am here to partner and support you and your child.",
    activity_log:
      "As a parent, you can support your child by working on the skills mentioned above and watching for additional communication from the school. I've also included an activity log below that you can use to track skills practice at home.",
    Domain: "Domain",
    PR: "PR",
    Status: "Status",
    Description: "Description",
    "Home Activity Log": "Home Activity Log",
    Goal: "Goal",
    "Activity we tried": "Activity we tried",
    how_it_went: "How it went (Circle a face)",
    example_goal: "Example Goal: Learn letter sounds",
    example_activity:
      "Example Activity: Look at a page in a familiar book with your child, ask them which letters they recognize and the sounds associated with those letters.",
  },
  badge_certificate: {
    your_award: "YOUR {{brandedAppName}} AWARD",
    honors_you_for: "{{brandedAppName}} Honors You For",
    achieved: "Achieved",
  },
  reports: {
    title: "Select a Report",
    review_activity: "Review Activity",
    reports: "Reports",
    log_out: "Log Out",
    help: "Help",
    bilingual: "Bilingual",
    english: "English",
    "Batch Print": "Batch Print",
    generating_batch_report: "Generating Batch Print Report",
    seconds_left: "About {{seconds}} seconds remaining",
    minutes_left: "About {{minutes}} minutes remaining",
    "Exit Batch Print": "Exit Batch Print",
    no_scores_available: "No scores available yet",
    work_with_amira: "work with {{brandedAppName}}",
    works_with_amira: "works with {{brandedAppName}}",
    once_your_student: "Once your student",
    once_your_students: "Once your students",
    you_can_view_their: "you will be able to view their",
    here: "here",
    assessments_must_clear:
      "Assessments may take up to overnight to score and up to 72 hours to clear {{brandedAppName}}'s quality review process.",
    no_adjusted_scores: "No adjusted scores available yet",
    completes_equated_activity:
      "completes an activity that supports score adjustment with {{brandedAppName}}",
    complete_equated_activity:
      "complete an activity that supports score adjustment with {{brandedAppName}}",
    switch_to_unadjusted:
      'Switch to the "Unadjusted (raw scores)" score type to view reporting on all activity.',
    // reports homepage
    tracking_label: "TRACKING REPORT",
    tracking_description: "View status and assign assessments",
    tracking_tagline: "assessment status; manage assignments",
    benchmark_label: "BENCHMARK REPORT",
    benchmark_description: "Overview class performance",
    benchmark_tagline:
      "compared to expectations, interventions, cut lines, student ranking",
    progress_label: "PROGRESS REPORT",
    progress_description: "View performance over time",
    progress_tagline:
      "student recordings, progress monitoring, trend line, student growth",
    readingrope_label: "INSTRUCTIONAL RECOMMENDATIONS",
    readingrope_description: "Visualization of mastery using the Reading Rope",
    readingrope_tagline:
      "Scores each student to drive an overall mastery score with instructional recommendations",
    skillsstatus_label: "SKILLS STATUS",
    skillsstatus_description: "Skill level mastery class-wide",
    skillsstatus_tagline:
      "View and group mastery status of every skill for all the students in your class",
    skillsdiagnostic_label: "SKILLS DIAGNOSTIC",
    skillsdiagnostic_description: "Holistic view of each student",
    skillsdiagnostic_tagline:
      "Review mastery level of each skill in every component of the reading rope for individual students",
    classprogress_label: "CLASS PROGRESS REPORT",
    classprogress_description: "Compare assessment scores over time",
    classprogress_tagline:
      "View progress for all students in your class across a range of metrics",
    dyslexiarisk_label: "DYSLEXIA RISK REPORT",
    dyslexiarisk_description: "Identify at-risk students",
    dyslexiarisk_tagline: "cut lines, likelihood of dyslexia",
    badging_label: "BADGING REPORT",
    badging_description: "View and award badges",
    badging_tagline:
      "Celebrate usage and achievement for students in your class",
    parent_label: "PARENT REPORT",
    parent_description: "Share parent-friendly updates",
    parent_tagline: "Overview of progress, opportunities to support growth",
    // tooltips
    tooltip_scoreType:
      "Adjusted scores account for differences in the difficulty of the passages read.",
    tooltip_scale: "Change the scale to Lexile, DRA, or WCPM.",
    tooltip_benchmarks:
      "National benchmarks are based on the results from students across the country. If present, District benchmarks are provided to {{brandedAppName}} by your District.",
    tooltip_metric:
      "Change the scale to Oral Reading Fluency, Amira Reading Mastery, Reading Mastery, High Frequency Words, Phonological Awareness, or Vocabulary Size.",
    tooltip_curriculum:
      "Choose a curriculum to view its scope & sequence in this report. To see your students' progress through the early reader skill scaffold, choose {{curriculumName}}",
    tooltip_pr:
      "The PR is the student's Percentile Ranking, based on the student's performance compared to other students associated with the selected benchmark.",
    tooltip_readingLevel:
      "In Science of Reading, students are not leveled. This data should be used only as an indication of the text complexity the student is able to tackle without frustration.",
    tooltip_riskLevel:
      "Risk is not diagnosis. {{brandedAppName}} provides an early warning if a student seems to be evidencing the reading behaviors associated with Dyslexia.",
    tooltip_atRisk:
      'Any student scoring above 30 is "at risk". Stronger signals vary by grade but typically are associated with scores in the mid-thirties and above.',
    // legend
    "English Reading Risk": "English Reading Risk",
    "Spanish Reading Risk": "Spanish Reading Risk",
    "At Risk, Stronger Signals": "At Risk, Stronger Signals",
    "At Risk, Weaker Signals": "At Risk, Weaker Signals",
    "Low Risk": "Low Risk",
    "Risk Cutline": "Risk Cutline",
  },
  reports_sidebar: {
    // translations for report sidebar
    back_to_reports: "BACK TO ALL REPORTS",
    "Tracking Report": "Tracking Report",
    "Benchmark Report": "Benchmark Report",
    "Progress Report": "Progress Report",
    "Reading Rope": "Reading Rope",
    "Skills Status": "Skills Status",
    "Skills Diagnostic": "Skills Diagnostic",
    "Class Progress Report": "Class Progress Report",
    "Dyslexia Risk": "Dyslexia Risk",
    "Badging Report": "Badging Report",
    "Parent Report": "Parent Report",
    score_configuration: "SCORE CONFIGURATION",
    metric: "METRIC",
    ARM: "Amira Reading Mastery (ARM)",
    ORF: "Oral Reading Fluency (ORF)",
    SightRecognition: "High Frequency Words",
    PhonologicalAwareness: "Phonological Awareness",
    VocabSize: "Vocabulary Size",
    score_type: "SCORE TYPE",
    equated: "Adjusted (for comparability)",
    unequated: "Unadjusted (raw scores)",
    scale: "SCALE",
    WCPM: "Words Correct Per Minute (WCPM)",
    Lexile: "Lexile measure (based on grade equivalency)",
    DRA: "Developmental Reading Assessment",
    benchmarks: "BENCHMARKS",
    "National Norms": "National Norms",
    "Spanish Norms": "Spanish Norms",
    District: "District",
    Kindergarten: "Kindergarten",
    "Grade 1": "Grade 1",
    "Grade 2": "Grade 2",
    "Grade 3": "Grade 3",
    "Grade 4": "Grade 4",
    "Grade 5": "Grade 5",
    "Grade 6": "Grade 6",
    language: "LANGUAGE",
    english: "English",
    spanish: "Spanish",
    reading_risk_type: "READING RISK TYPE",
    english_reading_risk: "English Reading Risk",
    spanish_reading_risk: "Spanish Reading Risk",
    testing_window: "TESTING WINDOW",
    Fall: "Fall",
    Winter: "Winter",
    Spring: "Spring",
    current: "current",
    assessment_type: "ASSESSMENT TYPE",
    benchmark_only: "Benchmark Assessment Only",
    latest_assessment: "Latest Assessment (including progress monitoring)",
    configuration: "CONFIGURATION",
    show_subscores: "Show Subscores",
    show_tips: "Show Tips",
    Decoding: "Decoding",
    "Phonological Awareness": "Phonological Awareness",
    "High Frequency Words": "High Frequency Words",
    "Background Knowledge": "Background Knowledge",
    Vocabulary: "Vocabulary",
    "Structures & Reasoning": "Structures & Reasoning",
    badges_earned_in: "Show Badges Earned In:",
    usage_window: "USAGE WINDOW",
    school_year: "School Year",
    this_week: "This Week ({{labelStart}} - {{labelEnd}})",
    last_week: "Last Week ({{labelStart}} - {{labelEnd}})",
    usage_week: "{{labelStart}} - {{labelEnd}}",
    curriculum: "CURRICULUM",
    "Amira Default": "Amira Default",
    "EPS Spire": "EPS Spire",
    "Type or select a student": "Type or select a student",
    "Loading student data": "Loading student data",
    "Select...": "Select...",
    "report_type": "REPORT TYPE",
    "class_progress": "Class Progress",
    "thread_overview": "Thread Overview",
  },
  tracking_report: {
    "First Name": "First Name",
    "Last Name": "Last Name",
    "Tutoring Time": "Tutoring Time",
    "Stories Read": "Stories Read",
    "This Week": "This Week",
    "Review Skills": "Review Skills",
    "Assessment Status": "Assessment Status",
    Language: "Language",
    // assessment statuses
    unassessed: "Unassessed",
    assigned: "Scheduled",
    in_progress: "In Progress",
    error: "Reassess",
    scoring: "Scoring",
    complete: "Complete",
    under_review: "Under Review",
    "pre-reader": "Early Reader",
    incomplete: "Not Completed",
    district_assigned: "District Assigned",
    // assessment status labels
    unassessed_label: "Unassessed",
    assigned_label: "Scheduled on {{month}}/{{day}}",
    in_progress_label: "In Progress",
    error_label: "Reassess {{month}}/{{day}}",
    scoring_label: "Scoring {{month}}/{{day}} Test",
    complete_label: "Complete {{month}}/{{day}}",
    under_review_label: "Under Review {{month}}/{{day}}",
    "pre-reader_label": "Early Reader {{month}}/{{day}}",
    incomplete_label: "Not Completed {{month}}/{{day}}",
    district_assigned_label: "District Assigned",
    // assessment status tooltips
    means: "means",
    unassessed_description:
      "the student has not been assigned an assessment in the <b>current</b> testing window. If your school is using {{brandedAppName}} Practice, the student will get Practice stories until an assessment is assigned.",
    [`unassessed_description_nwea-map-tutor_override`]:
      "the student has not been assigned an assessment in the <b>current</b> testing window. If your school is using MAP Reading Fluency assessments, the student will get practice stories until assigned.",
    unassessed_cta:
      "To assess the student, assign an assessment, then instruct the student to log-in to {{brandedAppName}} as they normally would.",
    [`unassessed_cta_nwea-map-tutor_override`]:
      "To assess the student, utilize MAP Reading Fluency to assign a benchmark test and execute student testing there.",
    assigned_description:
      "the student has been assigned an assessment and will be given the assessment the next time the student logs in.",
    assigned_cta: "Instruct the student to log in and complete the assessment.",
    in_progress_description:
      "the student is currently taking an assessment. The assessment will be scored when completed.",
    in_progress_cta:
      "After the student has finished the assessment, check the score on the Benchmark Report. If the student logged out during the assessment, the student will be able to complete the assessment upon the next login.",
    error_description:
      "the student completed the assessment, but an issue occurred that does not allow for a valid score. Some criteria in consideration include loud background noise, difficult audio conditions for accurate scoring, and too short of a reading attempt to properly estimate the student's ability. These signals indicate that re-assessing this student might produce meaningfully different results.",
    error_cta:
      "Click on the student's name and re-assign this assessment, then instruct the student to log in to take the assessment. (Prior to reassessing, check the student's headphones or open tabs which might be interfering with the audio file.)",
    scoring_description:
      "the assessment has been saved and is in the scoring process. Scoring can take a few minutes or up to several hours to complete.",
    scoring_cta:
      "Wait for the scoring process to finish, then check the score on the Benchmark Report. If the status of SCORING is displayed for more than 24 hours, Chat with us or contact support.",
    complete_description:
      "the student has completed the assessment. The student's score is available in the Benchmark Report.",
    complete_cta:
      "If your school is using {{brandedAppName}} Practice, ask the student to log in and work with {{brandedAppName}} several times a week.",
    under_review_description:
      "the assessment session has been flagged for an in-depth quality review. The review process can take 3 business days, not including the day the assessment was taken. For example, an assessment completed on Monday will be reviewed by Friday morning.",
    under_review_cta:
      'Check back in a few days. The status will change to "Complete" or "Reassess" once reviewed. If this takes more than 5 business days, please contact Support or Chat with us.',
    "pre-reader_description":
      "the student struggled to read the kindergarten passage or the student did not read enough words correctly to enable a score.",
    "pre-reader_cta":
      "If you agree the student is an early reader, ask them to login and work with {{brandedAppName}} through the early skills scaffold. If you disagree, review the student's audio and if you then judge that the student is a solid reader, either remove from the Skills Scaffold or assign a new assessment.",
    not_completed_description:
      "the student's session ended before the assessment was completed. This can occur because the student is closing or leaving the browser.",
    not_completed_cta:
      "Instruct the student to log in and resume the assessment.",
    district_assigned_description:
      "your district has created an assessment window. This student will be assessed as soon as they launch {{brandedAppName}}.",
    district_assigned_cta:
      "Instruct the student to log in and complete the assessment.",
    // controls
    "Assign Benchmark Assessment": "Assign Benchmark Assessment",
    "Assign Progress Monitor": "Assign Progress Monitor",
    "Assign Calibration": "Assign Calibration",
    "Configure Practice": "Configure Practice",
    "Configure District Assessment": "Configure District Assessment",
    "Unassign Assessment": "Unassign Assessment",
    // assignment
    benchmark_label: "BENCHMARK SCREENER",
    benchmark_description:
      "These students will get the benchmark screener next",
    progress_monitoring_label: "PROGRESS MONITOR",
    progress_monitoring_description:
      "These students will get the progress monitor next",
    calibration_label: "CALIBRATION",
    calibration_description:
      "These students will get the calibration form next",
    "STUDENT ASSESSMENT CONFIGURATION": "STUDENT ASSESSMENT CONFIGURATION",
    sessions: "{{count}} Session",
    sessions_plural: "{{count}} Sessions",
    "English Only": "English Only",
    "Spanish Only": "Spanish Only",
    "English & Spanish": "English & Spanish",
    "Manage Language": "Manage Language",
    assessment_configuration: "{{studentName}}'s Assessment Configuration",
    "SELECT LANGUAGES": "SELECT LANGUAGES",
    English: "English",
    Spanish: "Spanish",
    TASKS: "TASKS",
    tasks_description:
      "The following tasks will appear in the upcoming assessment. These have been configured by your district. The Target Badges indicate their correspondence with the Reading Rope report.",
    Task: "Task",
    Description: "Description",
    "Reading Rope Domains": "Reading Rope Domains",
    // tasks
    assessment_name: "Oral Reading Fluency",
    assessment_info:
      "This task consists of reading a passage to ascertain overall fluency and other threads of mastery. The passage will be dynamically adapted to better gauge student ability.",
    nwf_name: "Nonsense Word Fluency",
    nwf_info:
      "This task requires the student to read non-words in order to assess decoding skills.",
    spelling_name: "Spelling",
    spelling_info:
      "Student ability to spell and encode will be tested with this task.",
    listeningComprehension_name: "Listening Comprehension",
    listeningComprehension_info:
      "Students will answer questions about a story they've heard in order to gauge their listening comprehension skills.",
    vocabularyScreener_name: "Vocabulary",
    vocabularyScreener_info:
      "This task consists of choosing a descriptor or picture that best matches the definition of a word.",
    readingComprehension_name: "Reading Comprehension",
    readingComprehension_info:
      "Students will answer questions about the passage they've read to gauge their comprehension skills.",
    ran_name: "RAN",
    ran_info:
      "Rapid automized naming requires the student to identify and articulate the elements of a long list. Processing speed and accuracy are measured.",
    letterSounds_name: "Letter Sounds",
    letterSounds_info:
      "The student is shown a letter and asked to make the associated sound.  For vowels, several alternatives are accepted.",
    wordReading_name: "Word Reading",
    wordReading_info:
      "The student is shown the text of words, one at a time.  The student must read the word.",
    blending_name: "Blending",
    blending_info:
      "A video is provided of a person slowly articulating each phoneme in a word.  The students must blend the sound into the complete word accurately.",
    calibration_name: "Calibration",
    calibration_info:
      "This task consists of reading a passage to ascertain overall fluency and other threads of mastery. The passage will be dynamically adapted to better gauge student ability.",
    wordManipulation_name: "Word Manipulation",
    wordManipulation_info:
      "This task requires the student to manipulate words in various ways to assess their understanding of word structure and phonetics.",
    nonsenseWordReplication_name: "Nonsense Word Replication",
    nonsenseWordReplication_info:
      "In this task, the student is asked to replicate the pronunciation of nonsense words to assess their phonetic decoding skills.",
    letterNamingAndSounds_name: "Letter Naming and Sounds",
    letterNamingAndSounds_info: "The student is shown a letter and asked to name the letter and make the associated sound.",
    // practice modal
    practiceModalSubject: "{{studentName}} and {{count}} other student",
    practiceModalSubject_plural: "{{studentName}} and {{count}} other students",
    configure_practice: "Configure practice for {{subject}}",
    practice_reading: "{{subject}} will practice reading in",
    "English and Spanish": "English and Spanish",
    "District Default": "District Default",
    Next: "Next",
    Update: "Update",
    Configure: "Configure",
    practice_for: "practice for {{subject}}",
    amira_label: "Standard {{brandedAppName}} Practice",
    amira_description:
      "Students read stories aloud with help from {{brandedAppName}} in the form of micro-interventions",
    erss_label: "Early Reader Skill Scaffold",
    erss_description: "A heavily scaffolded sequence of practice activities",
    tutor_language_config:
      "{{brandedAppName}} will tutor {{subject}} in the following language",
    configure_bilingual_assessment:
      "Configure bilingual assessments for {{subject}}",
    only_bilingual_updated: "Note: Only bilingual students will be updated",
    district_assignments_taken_in:
      "District assignments for {{subject}} will be taken in:",
    // activity modal
    "Activity This Week": "Activity This Week",
    "Less than 1 minute": "Less than 1 minute",
    minute: "minute",
    minute_plural: "minutes",
    "Minutes Reading": "Minutes Reading",
    "Tutoring Time": "Tutoring Time",
    "Completed Stories": "Completed Stories",
    "Incomplete Stories": "Incomplete Stories",
    // warnings
    replace_district_assessment:
      "This Assignment will replace the scheduled District Assessment. This is okay but be sure that’s what you wish to do.",
    proceed_with_assignment: "Proceed With Your Assignment",
    cancel_and_use_district_assignment: "Cancel & Use District Assignment",
    no_assignable_students:
      "There are no assignable students left to receive this calibration assignment.",
    // screening window
    active_screening_window: "There's an active screening window for your district. Students that log in will get an assessment. You don't need to take any action at this time.",
    screening_window_set: "Screening Window Set - {{window}} Assessment",
    active_ends_on: "Active - Ends on {{month}}/{{day}}",
    benchmark_screener: "Benchmark Screener",
  },
  benchmark_report: {
    Student: "Student",
    "25th PR": "25th PR",
    "50th PR": "50th PR",
    "75th PR": "75th PR",
    "No Arm Score": "No Arm Score",
    Unassessed: "Unassessed",
    "Instructional Text Complexity": "Instructional Text Complexity",
    "Level A": "Level A",
    "Level B": "Level B",
    "Level C": "Level C",
    "Level D": "Level D",
    "Level E": "Level E",
    "Level F": "Level F",
    "Level G": "Level G",
    "Level H": "Level H",
    "Level I": "Level I",
    "Level J": "Level J",
    "Level K": "Level K",
    "Level L": "Level L",
    "Level M": "Level M",
    "Level N": "Level N",
    "Level O": "Level O",
    "Level P": "Level P",
    "Level Q": "Level Q",
    "Level R": "Level R",
    "Level S": "Level S",
    "Level T": "Level T",
    "Level U": "Level U",
    "Level V": "Level V",
    "Level W": "Level W",
    "Level X": "Level X",
    "Level Y": "Level Y",
    "Level Z": "Level Z",
  },
  badging_report: {
    "BACK TO BADGING REPORT": "BACK TO BADGING REPORT",
    newBadgeNotification: "You have {{count}} new badge to award!",
    newBadgeNotification_plural: "You have {{count}} new badges to award!",
    "Award All": "Award All",
    "My class usage": "My class usage",
    "Our Students": "Our Students",
    "Showing usage data": "Showing usage data",
    "and badges earned": "and badges earned",
    "for the entire school year": "for the entire school year",
    for_usage_week: "for {{labelStart}} - {{labelEnd}}",
    badges: "badges",
    stories: "stories",
    minutes: "minutes",
    "Last Name": "Last Name",
    "First Name": "First Name",
    "Tutoring Time": "Tutoring Time",
    "Stories Read": "Stories Read",
    "Badges Earned": "Badges Earned",
    "New Awards": "New Awards",
    "Total Sessions": "Total Sessions",
    "Minutes This Week": "Minutes this Week",
    WCPM: "WCPM",
    "Skills Scaffold Graduation": "Skills Scaffold Graduation",
    "New High": "New High",
    "Built By You": "Built by You",
    awardButton: "Award {{count}} Badge",
    awardButton_plural: "Award {{count}} Badges",
    printButton: "Print {{count}} Badge",
    printButton_plural: "Print {{count}} Badges",
    "Build Certificates": "Build Certificates",
    "Export to CSV": "Export to CSV",
    "Usage Data": "Usage Data",
    "Certificate Builder": "Certificate Builder",
    "Reward Level": "Reward Level",
    Language: "Language",
    "Class Name": "Class Name",
    English: "English",
    Spanish: "Spanish",
    Description: "Description",
    "Create Badges": "Create Badges & Print Certificates",
    Cancel: "Cancel",
    Preview: "Preview",
    "Coming Soon!": "Coming Soon!",
    // print certificates modal
    "Print Certificates": "Print Certificates",
    award_eligible_badges:
      'Some of the badges in your selection have not yet been awarded. Click "Proceed" to award eligible badges before printing certificates.',
    "Certificate Color": "Certificate Color",
    select_certificate_color:
      "Select whether to print certificates in color or black/white.",
    Color: "Color",
    "Black/White": "Black/White",
  },
  progress_report: {
    Fall: "Fall",
    Winter: "Winter",
    Spring: "Spring",
    "Predicted Ability": "Predicted Ability",
    "Estimated Mastery Today": "Estimated Mastery today",
    "by end of school year": "by end of school year",
    "Percentile Rank": "Percentile Rank",
    "based on National Norms": "based on national norms",
    "Activity Type": "Activity Type",
    ARM: "ARM",
    "Story Name": "Story Name",
    "Story Grade": "Story Grade",
    "Session Time": "Session Time",
    Date: "Date",
    Above: "Above",
    Below: "Below",
  },
  reading_rope_report: {
    Vocabulary: "Vocabulary",
    "Background Knowledge": "Background Knowledge",
    "Structures & Reasoning": "Structures\u00A0& Reasoning",
    "Structure & Reasoning": "Structure & Reasoning",
    "Phonological Awareness": "Phonological Awareness",
    Decoding: "Decoding",
    "High Frequency Words": "High Frequency Words",
    Comprehension: "Comprehension",
    "Overall Mastery": "Overall Mastery",
    Percentile: "Percentile",
    "ARM Score": "ARM Score",
    "Word Recognition": "Word Recognition",
    "Current Mastery": "Current Mastery",
    "current_mastery_with_name": "Current Mastery for {{studentName}}",
    "What's Next": "What's Next",
    "To Improve...": "To Improve...",
    "Skills Coming Soon...": "Skills Coming Soon...",
    "View Details": "View Details",
  },
  skills_status_report: {
    "Student Name": "Student Name",
    Fall: "Fall",
    Winter: "Winter",
    Spring: "Spring",
    "Pre-K": "Pre-K",
    Kindergarten: "Kindergarten",
    "First Grade": "First Grade",
    "Second Grade": "Second Grade",
    "Third Grade": "Third Grade",
    "Fourth Grade": "Fourth Grade",
    "Fifth Grade": "Fifth Grade",
    "Sixth Grade": "Sixth Grade",
    "Not Developed": "Not Developed",
    Developing: "Developing",
    Mastered: "Mastered",
    observation: "observation",
    observation_plural: "observations",
    error: "error",
    error_plural: "errors",
    "Skill Level": "Skill Level",
    "Pre-K": "Pre-K",
    Resources: "Resources",
    no_resources: "No resources to display.",
    fetch_error: "Error: unable to retrieve diagnostic report.",
  },
  class_progress_report: {
    "At/Above": "At/Above",
    "On Track": "On Track",
    Developing: "Developing",
    Behind: "Behind",
    "Fall (BOY)": "Fall (BOY)",
    "Winter (MOY)": "Winter (MOY)",
    "Spring (EOY)": "Spring (EOY)",
    "Estimated Mastery Today": "Estimated Mastery",
    PR: "PR",
    Latest: "Latest",
    "Word Recognition": "Word Recognition",
    "Comprehension": "Comprehension",
    "Fluency": "Fluency",
    "PA": "PA",
    "DCD": "DCD",
    "WR": "WR",
    "VCB": "VCB",
    "CMP": "CMP",
    "WCPM": "WCPM",
    "ARM": "ARM",
  },
  dyslexia_risk_report: {
    Student: "Student",
    "Risk Level": "Risk Level",
    "Print Letters": "Print Letters",
    "Under Review": "Under Review",
  },
  parent_report: {
    "Print Parent Letters": "Print Parent Letters",
    select_optional_attachments: "Select optional attachments to include",
    "Home Activity Log": "Home Activity Log",
    "Print letter in": "Print letter in",
  },
  review_activity: {
    title: "Select a Recent Activity to Review",
    Assessment: "Assessment",
    Practice: "Practice",
    "Letter Names and Sounds": "Letter Names and Sounds",
    "Letter Names and Sounds Rescoring Warning": "Rescoring for the letter names and sounds activity has been disabled in your district or school. Please contact your district or school leader for assistance.",
    Adjusted: "Adjusted",
    Unadjusted: "Unadjusted",
    WCPM: "WCPM",
    ASSESSMENT: "ASSESSMENT",
    PRACTICE: "PRACTICE",
    COMPLETE: "COMPLETE",
    INCOMPLETE: "INCOMPLETE",
    "UNDER REVIEW...": "UNDER REVIEW...",
    "Go To The": "Go To The",
    "Tracking Report": "Tracking Report",
    "correction_header": "Scoring {{studentName}}'s {{activityType}} On {{month}}/{{day}}",
    "Correct": "Correct",
    "Incorrect": "Incorrect",
    "Not Read": "Not Read",
    "Flagged": "Flagged",
    "Errors": "Errors",
    "Self Corrections": "Self Corrections",
    "Skips": "Skips",
    "Mistakes": "Mistakes",
    "Totals": "Totals",
    "Accuracy": "Accuracy",
    "Status": "Status",
    "COMPLETE": "COMPLETE",
    "Adjusted WCPM": "Adjusted WCPM",
    "Adjusted Read Time": "Adjusted Read Time",
    "Questions?": "Questions?",
    "Scoring Reading Activity": "Scoring Reading Activity",
    "SAVE CHANGES": "SAVE CHANGES",
    // review activity tooltips
    tooltip_correct: "The student can accurately read this word.",
    tooltip_incorrect: "The student did not correctly decode this word. Listen to identify student errors.",
    tooltip_not_read: "In the time allotted, the student did not complete the story. This part of the passage is not included in scoring and does not impact the WCPM score.",
    tooltip_flagged: "A disruption of sound or technology made this inaudible for {{brandedAppName}}. A teacher should listen and re-score this word.",
    tooltip_error: "Words incorrectly read or skipped by the student.",
    tooltip_self_corrections: "This is indicated when a child initially misreads a word and then corrects themselves.  If a child attempts many times, the teacher might need to adjust the score.",
    tooltip_skips: "Situations where the  student skipped over the word.",
    tooltip_miscues: "Accounts for only student errors, not words omitted.",
    tooltip_accuracy: "This is determined by the number of correct words divided by possible words read.  The score does not incorporate words skipped at the end of a passage.",
    tooltip_adj_wcpm: "This is WCPM with consideration of text complexity.  It is not a raw score that can be manually calculated.  The raw WCPM is available in the Progress Report.",
    // scoring faq
    default_title: "How do I change a word’s score?",
    default_content: "To change a word from correct to incorrect, just click on the word.\nTo get the details on scoring, click",
    "this link": "this link",
    early_next_button_title: "Did the student move to the next page before they were finished reading?",
    early_next_button_content: "This student likely pressed the Next Button too early, which is why there is a long string of errors.\{{brandedAppName}} scores this as a SKIP.\nThis does not impact a student's WCPM score, but may depress {{brandedAppName}}'s overall assessment of this student’s mastery.\nIf you are concerned that the student is scored too low, you should reassess.",
    inconsistent_time_title: "Why is this WCPM using an adjusted time?",
    inconsistent_time_content: "The time used to calculate WCPM has been adjusted because of extraneous activity or the student stopped reading.\nWithout this adjustment, the WCPM would be off.",
  },
  admin_assessment_configuration: {
    config_grade_banner_title:
      "{{grade}} Configuration Exceeds Maximum Recommended Time",
    config_grade_banner_message:
      "The maximum assessment time recommended for {{grade}} is {{expectedTime}} minutes. The total time for {{grade}} is currently {{totalTime}} minutes",
  },
  admin_benchmark_configuration: {
    select_grades: "Choose Grades to Include",
    disable_by_grade_warning:
      "Some schools has their own grades to include settings, if you change this setting, it will override the school settings.",
    window_disabled_by_grade_warning:
      "The following grade is excluded from this screening window: {{disabledGradesString}}",
    window_disabled_by_grade_warning_plural:
      "The following grades are excluded from this screening window: {{disabledGradesString}}",
  },
  tutor_assignment_modal: {
    add_assignment: "Add Assignment",
    add_an_assignment: "Add an Assignment",
    an_assignment_has_been_added_for_number_students: "An assignment has been added for {{number}} student",
    an_assignment_has_been_added_for_number_students_plural: "An assignment has been added for {{number}} students",
    the_assignment_could_not_be_created_try_again: "The assignment could not be created. Try Again.",
    show_all_assignable_stories_from_skyline_for: "Show all assignable stories from Skyline for",
    with: "with",
    that_cover: "that cover",
    assign: "Assign",
    dismiss: "Dismiss",
    please_select_students: "Please select students",
    this_story_has_already_been_added_to_students: "This story has already been assigned to {{students}}",
    see_assignments: "See Assignments",
  }
};
